import { render, staticRenderFns } from "./CustomDisabledCheckbox.vue?vue&type=template&id=4fe03620&scoped=true&"
import script from "./CustomDisabledCheckbox.vue?vue&type=script&lang=js&"
export * from "./CustomDisabledCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./CustomDisabledCheckbox.vue?vue&type=style&index=0&id=4fe03620&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe03620",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fe03620')) {
      api.createRecord('4fe03620', component.options)
    } else {
      api.reload('4fe03620', component.options)
    }
    module.hot.accept("./CustomDisabledCheckbox.vue?vue&type=template&id=4fe03620&scoped=true&", function () {
      api.rerender('4fe03620', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Forms/CustomDisabledCheckbox.vue"
export default component.exports